<template>
  <div class="as-injuries-suspensions">
    <div
      class="as-line-up-colunm"
      :class="{
        'as-line-up-colunm-sm': screenWidth < 370,
      }"
    >
      <div class="as-line-up-colunm-item">
        <div class="as-line-up-item as-line-up-item-team as-line-up-item-home">
          <div class="as-match__team">
            <img
              class="as-match__team-logo"
              :src="
                getImgUrlBySport(
                  'team',
                  lineups?.coach?.home ? lineups.coach?.home?.team_id : match.home_team_id
                )
              "
            />
            <div class="as-match__team-name">
              {{ lineups?.coach?.home ? lineups.coach?.home?.name : match.home_team.name }}
            </div>
          </div>
        </div>
        <div
          v-for="(player, key) in startingPlayers.home"
          :key="key"
          class="as-line-up-item as-line-up-item-home"
        >
          <div class="as-player as-player-row">
            <a :href="getLinkPlayerDetail(player)" class="as-player-name">
              <img
                class="as-player-logo"
                :src="getImgUrlBySport('player', player.id)"
              />
              <div class="as-player-shirt-name">
                <span>{{ player.name }}</span>
                <span v-if="player.position" class="as-position">{{ getPosition(player.position) }}</span>
              </div>
            </a>

            <div class="as-player-injured">
              <span class="as-injured-suspended">
                <span :class="player.type === 1 ? 'as-injured' : 'as-suspended'">
                  {{ player.name_vi || player.name_en }}
                </span>
              </span>
              <svg v-if="player.type === 1" aria-hidden="true">
                <use xlink:href="#iconPlus"></use>
              </svg>
              <svg v-else-if="player.type === 2" aria-hidden="true">
                <use xlink:href="#iconFinish"></use>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="as-line-up-colunm-item">
        <div class="as-line-up-item as-line-up-item-team as-line-up-item-home">
          <div class="as-match__team">
            <img
              class="as-match__team-logo"
              :src="
                getImgUrlBySport(
                  'team',
                  lineups?.coach?.away ? lineups.coach?.away?.team_id : match.away_team_id
                )
              "
            />
            <div class="as-match__team-name">
              {{ lineups?.coach?.away ? lineups.coach?.away?.name : match.away_team.name }}
            </div>
          </div>
        </div>
        <div
          v-for="(player, key) in startingPlayers.away"
          :key="key"
          class="as-line-up-item as-line-up-item-away"
        >
          <div class="as-player as-player-row">
            <a :href="getLinkPlayerDetail(player)" class="as-player-name">
              <img
                class="as-player-logo"
                :src="getImgUrlBySport('player', player.id)"
              />
              <div class="as-player-shirt-name">
                <span>{{ player.name }}</span>
                <span v-if="player.position" class="as-position">{{ getPosition(player.position) }}</span>
              </div>
            </a>

            <div class="as-player-injured">
              <span class="as-injured-suspended">
                <span :class="player.type === 1 ? 'as-injured' : 'as-suspended'">
                  {{ player.name_vi || player.name_en }}
                </span>
              </span>
              <svg v-if="player.type === 1" aria-hidden="true">
                <use xlink:href="#iconPlus"></use>
              </svg>
              <svg v-else-if="player.type === 2" aria-hidden="true">
                <use xlink:href="#iconFinish"></use>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <NoData
      v-if="!startingPlayers.home.length && !startingPlayers.away.length"
      title="Không có dữ liệu"
      modifyClass="as-h-auto"
    />

    <svg
      aria-hidden="true"
      style="position: absolute; width: 0px; height: 0px; overflow: hidden"
    >
      <symbol id="iconFinish" width="16" height="16" viewbox="0 0 16 16">
        <g clip-path="url(#clip0_153_6988)">
          <path
            d="M4.04901 15.9865L4.34357 15.9041C4.6269 15.825 4.7924 15.5311 4.71323 15.2477L1.34542 3.19565C1.2979 3.02557 1.18475 2.88133 1.03088 2.79467C0.877004 2.70801 0.695006 2.68603 0.524923 2.73356L0.486882 2.74418C0.132682 2.84314 -0.0742295 3.2105 0.02473 3.5647L3.39262 15.6168C3.47179 15.9001 3.76567 16.0656 4.04901 15.9865Z"
            fill="#0C72CB"
          />
          <path
            d="M15.9093 7.56415C14.8413 7.03161 13.8533 6.35189 12.9741 5.54484C12.9002 5.47719 12.8713 5.37335 12.8996 5.27725C13.3352 3.6293 13.6587 1.95375 13.8679 0.26208C13.901 -0.0192994 13.7493 -0.102058 13.5893 0.0910454C10.45 3.84553 5.01826 -0.595851 1.78516 2.81656C1.82397 2.88924 1.85451 2.96604 1.87619 3.04553L4.06102 10.869C7.29964 7.49794 12.7121 11.9117 15.8458 8.16553C16.0058 7.97242 16.0362 7.61932 15.9093 7.56415Z"
            fill="#0C72CB"
          />
        </g>
        <defs>
          <clipPath id="clip0_153_6988">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </symbol>
      <symbol id="iconPlus" width="16" height="16" viewbox="0 0 16 16">
        <g clip-path="url(#clip0_153_7005)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM9.85059 3.07816L9.85056 3.07812H6.14947L6.14941 3.07819V6.14944L3.07809 6.14947V6.14953L3.07812 9.85053H3.07822H6.14944L6.14947 12.9218L6.1495 12.9219H9.85066V9.85056L12.922 9.85053L12.9219 6.14944H9.85063L9.85059 3.07816Z"
            fill="#CC4545"
          />
        </g>
        <defs>
          <clipPath id="clip0_153_7005">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </symbol>
    </svg>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from "vue";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";
import type { ILineups, IMatch, IStartingPlayers } from "~src/interfaces";
import NoData from "~src/components/NoData.vue";
import StatsEnum from "~src/enums/team-detail/StatsEnum";
const matchDetailStore = useMatchDetailStore();

interface IProps {
  lineups: ILineups;
  match: IMatch;
  startingPlayers: IStartingPlayers;
}

withDefaults(defineProps<IProps>(), {});

const screenWidth = computed(() => matchDetailStore.getScreenWidth);

const getPosition = (position: string) => {
  return StatsEnum.SHORT_POSITIONS[position as keyof typeof StatsEnum.SHORT_POSITIONS];
}
</script>

<script lang="ts">
export default {};
</script>
